import "./img_2.css";
// import Football from '../../../assets/Football.svg';
function Img_2() {
  return (
    <>
      <div className="container-fluid mt-5">
        <div className="img_cnt text-center mt-5">
          <div className="img_txt">
            <div className="ft">
            <h1 className="ft_txt">Refreshing Memories</h1>
            <h1 className="ft_txt1 mt-5">That Live Across</h1>
            <h1 className="ft_txt2 mt-5">Time.</h1>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Img_2;
